require("!!E:\\PopularHealth_n\\client\\node_modules\\script-loader\\addScript.js")(require("!!E:\\PopularHealth_n\\client\\node_modules\\raw-loader\\index.js!E:\\PopularHealth_n\\client\\node_modules\\source-map-loader\\index.js!E:\\PopularHealth_n\\client\\src\\assets\\modules\\fronend\\js\\tabber.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./src/assets/modules/fronend/js/tabber.js
// module id = ./node_modules/script-loader/index.js!./src/assets/modules/fronend/js/tabber.js
// module chunks = 4